export class ContinuanceListViewFilterModel {
    constructor(public clientId:  number[],
                public engagementPartner: string[],
                public solutionCodeId: number[],
                public loggedInUser: string) {
    }
}